import { useFieldSave } from '@/composables/useFieldSave'
import NaturalPersonController from '@controllers/NaturalPersonController'

const propsDerivedFromThePerson = ['person', 'spouse', 'children', 'profileCompletion', 'fieldStates']

export function usePersonUpdate<TPatch extends Record<string, unknown>>(
  personId: string,
  onSaved: (savedPatch: TPatch) => void,
): (patch: TPatch) => void {
  return useFieldSave<TPatch>({
    url: NaturalPersonController.update(personId).url,
    reloadProps: propsDerivedFromThePerson,
    onSaved,
  })
}
